/**
 * Bespoke triangle-motif icons for the Who We Serve grid.
 * All icons render on 40x40 viewbox, use currentColor for stroke,
 * and echo the Kairos logo's mountain-shape language.
 */

const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" };

export const IconCorrectional = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <polygon points="6,34 20,10 34,34" {...stroke} />
        <line x1="14" y1="34" x2="14" y2="22" {...stroke} />
        <line x1="20" y1="34" x2="20" y2="16" {...stroke} />
        <line x1="26" y1="34" x2="26" y2="22" {...stroke} />
        <circle cx="20" cy="19" r="1.2" fill="currentColor" />
    </svg>
);

export const IconMunicipal = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <polygon points="6,18 20,6 34,18" {...stroke} />
        <line x1="8" y1="18" x2="8" y2="34" {...stroke} />
        <line x1="16" y1="18" x2="16" y2="34" {...stroke} />
        <line x1="24" y1="18" x2="24" y2="34" {...stroke} />
        <line x1="32" y1="18" x2="32" y2="34" {...stroke} />
        <line x1="4" y1="34" x2="36" y2="34" {...stroke} />
    </svg>
);

export const IconNightlife = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <polygon points="10,32 20,14 30,32" {...stroke} />
        <polygon points="16,32 22,20 28,32" {...stroke} />
        <circle cx="20" cy="10" r="2" fill="currentColor" />
        <line x1="20" y1="7" x2="20" y2="4" {...stroke} />
    </svg>
);

export const IconNonprofit = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <polygon points="8,30 20,12 32,30" {...stroke} />
        <path d="M14 24 L20 30 L26 24" {...stroke} />
        <path d="M14 24 C14 20, 18 20, 20 24 C22 20, 26 20, 26 24" {...stroke} />
    </svg>
);

export const IconHealthcare = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <polygon points="6,34 20,8 34,34" {...stroke} />
        <line x1="20" y1="17" x2="20" y2="27" {...stroke} />
        <line x1="15" y1="22" x2="25" y2="22" {...stroke} />
    </svg>
);

export const IconSchool = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <polygon points="4,18 20,10 36,18 20,26 4,18" {...stroke} />
        <path d="M10 21 L10 28 C10 30, 20 32, 30 28 L30 21" {...stroke} />
        <line x1="34" y1="18" x2="34" y2="26" {...stroke} />
    </svg>
);
